export default "/public/img/GT-America-Regular.cd5abd4c.otf";